import { CHAMPIONSHIPS } from "./index";

export const markets = [
  {
    key: CHAMPIONSHIPS.PREMIER_LEAGUE,
    label: "Premier League",
    flag: "premierLeague",
  },
  {
    key: CHAMPIONSHIPS.SERIE_A,
    label: "Serie A",
    flag: "serieA",
  },
  {
    key: CHAMPIONSHIPS.SERIE_B,
    label: "Serie B",
    flag: "serieB",
  },
  {
    key: CHAMPIONSHIPS.LIGA_MX,
    label: "Liga Max",
    flag: "ligaMax",
  },
  {
    key: CHAMPIONSHIPS.BUNDESLIGA,
    label: "Bundesliga",
    flag: "bundesliga",
  },
  {
    key: CHAMPIONSHIPS.LA_LIGA,
    label: "La Liga",
    flag: "laLiga",
  },
  {
    key: CHAMPIONSHIPS.PRIMEIRA_LIGA,
    label: "Primeira Liga",
    flag: "primeiraLiga",
  },
  {
    key: CHAMPIONSHIPS.CHAMPIONS_LEAGUE,
    label: "Champions League",
    flag: "championsLeague",
  },
  {
    key: CHAMPIONSHIPS.EUROPA_LEAGUE,
    label: "Europa League",
    flag: "europaLeague",
  },
];
